module.exports = __webpack_public_path__ + "img/1.73f2c12e.webp";